import React from "react";

import { numberWithCommas } from "../../Helpers/Utils/Common";
import {
  formatDateNoTime,
  formatDateSeconds,
  getFullNameUser,
} from "../../Helpers/Utils/Common";

function printReceipt(props) {
  const marginTop = "-130%";
  const marginRight = "40px";
  const marginBottom = "-1000px";
  const marginLeft = "40px";
  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const headers = () => {
    return (
      <>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {window.company_name}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {window.company_address}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {" "}
            {window.company_vat_reg_tin}
          </label>
        </div>
        <div className="d-flex row justify-content-center">
          <label className="d-flex row justify-content-center print-text">
            {window.company_min}
          </label>
        </div>
        <div className="d-flex row justify-content-center">
          <label className="d-flex row justify-content-center print-text">
            {window.company_sn}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {window.company_ptu_no}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {window.company_issued_date}
          </label>
        </div>
      </>
    );
  };

  const footer = () => {
    return (
      <>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {window.myt_name}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
          {window.myt_address1}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
          {window.myt_address2}
          </label>
        </div>
        <div className="d-flex row justify-content-center ">
          <label className="d-flex row justify-content-center  print-text">
            {" "}
            {window.myt_vat_reg_tin}
          </label>
        </div>
        <div className="d-flex row justify-content-center">
          <label className="d-flex row justify-content-center  print-text">
            {window.myt_acc_no}
          </label>
        </div>
        <div className="d-flex row justify-content-center">
          <label className="d-flex row justify-content-center  print-text">
            {window.myt_issued_date}
          </label>
        </div>
      </>
    );
  };

  const contentItemReports = () => {
    let total = parseFloat(
      props.data.reduce((n, { total }) => n + parseFloat(total), 0)
    ).toFixed(2);
    let media = props.data.reduce((n, { count }) => n + parseFloat(count), 0);
    return (
      <>
        <div className="d-flex row justify-content-left ms-1">
          <label className="d-flex row justify-content-center print-text">
            {props.name}
          </label>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Cashier {getFullNameUser()}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Date {formatDateSeconds(new Date())}
          </div>
        </div>
        <div className="dotted-line"></div>
        <div className="row d-flex justify-content-center mb-1">
          <div className="col-5 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              Item
            </label>
          </div>
          <div className="col-1 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              Qty
            </label>
          </div>
          <div className="col-2 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              Price
            </label>
          </div>
          <div className="col-3 d-flex justify-content-end print-text text-right">
            <label d-flex justify-content-left print-text>
              Amount
            </label>
          </div>
        </div>
        <div className="row d-flex justify-content-center mb-1">
          {props.data.map((info) => {
            return (
              <>
                <div className="col-5 d-flex justify-content-left print-text">
                  {info.menu_name}
                </div>
                <div className="col-1 d-flex justify-content-center print-text">
                  {info.count}
                </div>
                <div className="col-2 d-flex justify-content-left print-text">
                  {numberWithCommas(info.price)}
                </div>
                <div className="col-3 d-flex justify-content-end print-text text-right">
                  {numberWithCommas(info.total)}
                </div>
              </>
            );
          })}
        </div>
        <div className="dotted-line"></div>
        <div className="row">
          <div className="col d-flex justify-content-left print-text">
            Total Amount: {numberWithCommas(total)}
          </div>
        </div>
        <div className="row">
          <div className="col d-flex justify-content-left print-text">
            Total Media: {media}
          </div>
        </div>
      </>
    );
  };

  const contentCashCountReport = () => {
    return (
      <>
        {props.data.map((info) => {
          let totalMedia =
            parseFloat(info.bill_1000) +
            parseFloat(info.bill_500) +
            parseFloat(info.bill_200) +
            parseFloat(info.bill_100) +
            parseFloat(info.bill_50) +
            parseFloat(info.bill_20) +
            parseFloat(info.coin_10) +
            parseFloat(info.coin_5) +
            parseFloat(info.coin_1) +
            parseFloat(info.cent_25) +
            parseFloat(info.cent_10) +
            parseFloat(info.cent_5) +
            parseFloat(info.cent_1);

          return (
            <>
              <div className="d-flex row justify-content-left ms-1">
                <label className="d-flex row justify-content-center print-text">
                  {props.name}
                </label>
              </div>
              <div className="row mt-2">
                <div className="col d-flex justify-content-left print-text">
                  Cashier {info.added_by}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col d-flex justify-content-left print-text">
                  Date {formatDateSeconds(info.added_on)}
                </div>
              </div>
              <div className="dotted-line"></div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Media Name
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  QTY
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  Amount
                </div>
              </div>
              {/** COUNTS ---------------------------------- */}
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 1000
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_1000}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas(
                    (1000 * parseInt(info.bill_1000)).toFixed(2)
                  )}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 500
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_500}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((500 * parseInt(info.bill_500)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 200
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_200}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((200 * parseInt(info.bill_200)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 100
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_100}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((100 * parseInt(info.bill_100)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 50
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_50}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((50 * parseInt(info.bill_50)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Bill 20
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.bill_20}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((20 * parseInt(info.bill_20)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Coin 10
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.coin_10}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((10 * parseInt(info.coin_10)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Coin 5
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.coin_5}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((5 * parseInt(info.coin_5)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Coin 1
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.coin_1}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas(parseInt(info.coin_1).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Cent 25
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.cent_25}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((25 * parseInt(info.cent_25)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Cent 10
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.cent_10}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((10 * parseInt(info.cent_10)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Cent 5
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.cent_5}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas((5 * parseInt(info.cent_5)).toFixed(2))}
                </div>
              </div>
              <div className="row d-flex justify-content-center mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  Cent 1
                </div>
                <div className="col-3 d-flex justify-content-center print-text">
                  {info.cent_1}
                </div>
                <div className="col-5 d-flex justify-content-end print-text">
                  {numberWithCommas(parseInt(info.cent_1).toFixed(2))}
                </div>
              </div>
              {/** ---------------------------------------- */}
              <div className="dotted-line"></div>
              <div className="row">
                <div className="col d-flex justify-content-left print-text">
                  Total Amount: {info.physical_count}
                </div>
              </div>
              <div className="row">
                <div className="col d-flex justify-content-left print-text">
                  Total Media: {totalMedia}
                </div>
              </div>
            </>
          );
        })}
      </>
    );
  };

  const contentAdjustmentVoidReport = () => {
    let total = parseFloat(
      props.data.reduce((n, { total }) => n + parseFloat(total), 0)
    ).toFixed(2);
    let media = props.data.reduce((n, { count }) => n + parseFloat(count), 0);

    return (
      <>
        {/* <div className="row d-flex justify-content-center print-text mb-1">
                    For {formatDateNoTime(props.filter.date_from)} - {formatDateNoTime(props.filter.date_to)}
                 </div> */}
        <div className="d-flex row justify-content-left ms-1">
          <label className="d-flex row justify-content-center print-text">
            {props.name}
          </label>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Cashier {getFullNameUser()}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Date {formatDateSeconds(new Date())}
          </div>
        </div>
        {props.data.map((info) => {
          return (
            <>
              <div className="dotted-line pt-4"></div>
              <div className="row">
                <div className="col d-flex justify-content-left print-text">
                  Date{" "}
                  {props.name === "Void Trans. Report" ? "Voided" : "Cancelled"}{" "}
                  {formatDateSeconds(info.added_on)}
                </div>
              </div>
              <div className="dotted-line"></div>
              {info.status !== "voided" && (
                <div className="row mb-1">
                  <div className="col-3 d-flex justify-content-left print-text">
                    ITEM
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    OR No.
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    TYPE
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    REASON
                  </div>
                </div>
              )}
              {info.status === "voided" && (
                <div className="row mb-1">
                  <div className="col-4 d-flex justify-content-left print-text">
                    ITEM
                  </div>
                  <div className="col-4 d-flex justify-content-left print-text">
                    OR No.
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    REASON
                  </div>
                </div>
              )}
              {info.status !== "voided" && (
                <div className="row mb-1">
                  <div className="col-3 d-flex justify-content-left print-text">
                    {info.item}
                  </div>
                  <div className="col-3 d-flex justify-content-center print-text">
                    {info.order_id}
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    {info.status}
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    {info.reason}
                  </div>
                </div>
              )}
              {info.status === "voided" && (
                <div className="row mb-1">
                  <div className="col-4 d-flex justify-content-left print-text">
                    {info.item}
                  </div>
                  <div className="col-4 d-flex justify-content-left print-text">
                    {info.order_id}
                  </div>
                  <div className="col-3 d-flex justify-content-left print-text">
                    {info.reason}
                  </div>
                </div>
              )}
              <div className="dotted-line"></div>
              {(info.status === "voided" || info.status === "refunded") && (
                <div className="row mb-1">
                  <div className="col-5 d-flex justify-content-left print-text">
                    AUTHORIZED BY
                  </div>
                  <div className="col-1 d-flex justify-content-left print-text">
                    :
                  </div>
                  <div className="col-5">
                    <div className="dotted-line pt-4 d-flex justify-content-left print-text"></div>
                  </div>
                </div>
              )}
              {(info.status === "voided" || info.status === "refunded") && (
                <div className="row mb-1">
                  <div className="col-5 d-flex justify-content-left print-text">
                    SIGNATURE
                  </div>
                  <div className="col-1 d-flex justify-content-left print-text">
                    :
                  </div>
                  <div className="col-5">
                    <div className="dotted-line pt-4"></div>
                  </div>
                </div>
              )}
            </>
          );
        })}
        <br />
      </>
    );
  };

  const dailySalesReports = () => {
    let total = parseFloat(
      props.data.reduce((n, { total_sales }) => n + parseFloat(total_sales), 0)
    ).toFixed(2);
    return (
      <>
        <div className="row d-flex justify-content-center print-text mb-1">
          For {formatDateNoTime(props.filter.date_from)} -{" "}
          {formatDateNoTime(props.filter.date_to)}
        </div>
        <div className="d-flex row justify-content-left ms-1 mt-2">
          <label className="d-flex row justify-content-center print-text">
            {props.name}
          </label>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Cashier {getFullNameUser()}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Date {formatDateSeconds(new Date())}
          </div>
        </div>
        <div className="dotted-line"></div>
        <div className="row mb-1">
          <div className="col-4 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              DATE
            </label>
          </div>
          <div className="col-2 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              TYPE
            </label>
          </div>
          <div className="col-2 d-flex justify-content-left print-text">
            <label d-flex justify-content-left print-text>
              AMOUNT
            </label>
          </div>
        </div>
        {props.data.map((info) => {
          return (
            <>
              <div className="row mb-1">
                <div className="col-4 d-flex justify-content-left print-text">
                  <label d-flex justify-content-left print-text>
                    {info.sales_date}
                  </label>
                </div>
                <div className="col-2 d-flex justify-content-left print-text">
                  <label d-flex justify-content-left print-text>
                    {info.payment_type}
                  </label>
                </div>
                <div className="col-2 d-flex justify-content-left print-text text-right align-right">
                  <label d-flex justify-content-left print-text>
                    {numberWithCommas(info.total_sales)}
                  </label>
                </div>
              </div>
            </>
          );
        })}
        <div className="dotted-line"></div>
        <div className="row">
          <div className="col d-flex justify-content-left print-text ">
            Total Amount: {numberWithCommas(total)}
          </div>
        </div>
      </>
    );
  };

  const seniorPWDDiscountsReports = () => {
    let total = parseFloat(
      props.data.reduce(
        (n, { total_discount }) => n + parseFloat(total_discount),
        0
      )
    ).toFixed(2);
    let numOfSCPWD = 0;
    return (
      <>
        <div className="row d-flex justify-content-center print-text mb-1">
          For {formatDateNoTime(props.filter.date_from)} -{" "}
          {formatDateNoTime(props.filter.date_to)}
        </div>
        <div className="d-flex row justify-content-left mt-4 ms-1">
          <label className="d-flex row justify-content-center print-text">
            {props.name}
          </label>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Cashier {getFullNameUser()}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col d-flex justify-content-left print-text">
            Date {formatDateSeconds(new Date())}
          </div>
        </div>
        <div className="dotted-line"></div>
        <div className="row mb-1">
          <div className="col-2 d-flex justify-content-left print-text-x">
            TRANS NO.
            {/* DATE */}
          </div>
          <div className="col-3 d-flex justify-content-left print-text-x">
            ID
            {/* NO OF SC */}
          </div>
          <div className="col-3 d-flex justify-content-left print-text-x">
            NAME
          </div>
          <div className="col-2 d-flex justify-content-left print-text-x">
            AMT
          </div>
          <div className="col-2 d-flex justify-content-left print-text-x">
            TOTAL
          </div>
          {/* <div className="col-2 text-right d-flex justify-content-left print-text-x">
                        VAT
                    </div>
                    <div className="col-2 text-right d-flex justify-content-left print-text-x">
                        SC DISC 
                    </div>
                    <div className="col-2 text-right d-flex justify-content-left print-text-x">
                        NET SALES 
                    </div> */}
        </div>
        {props.data.map((info) => {
          let ids = info.ids.split("|");
          ids != null ? (numOfSCPWD += ids.length) : (numOfSCPWD = 0);
          let subtotals = info.subtotal.split("|");
          let names = info.names.split("|");
          return (
            <>
              <div className="row mb-1">
                <div className="col-2 d-flex justify-content-left print-text-x">
                  {info.trans_no}
                </div>
                <div className="col-3 d-flex justify-content-left print-text-x">
                  {ids.length !== 0 ? ids[0] : ""}
                </div>
                <div className="col-3  d-flex justify-content-left print-text-x">
                  {names.length !== 0 ? names[0] : ""}
                </div>
                <div className="col-2 d-flex justify-content-left print-text-x text-right align-right">
                  {subtotals.length !== 0 ? subtotals[0] : ""}
                </div>
                <div className="col-2 d-flex justify-content-left print-text-x text-right align-right">
                  {info.total_discount}
                </div>
              </div>
              {ids.length !== 0 &&
                ids.slice(1).map((data, index) => {
                  return (
                    <div className="row mb-1">
                      <div className="col-3"></div>
                      <div className="col-2 d-flex justify-content-left print-text">
                        {data}
                      </div>
                      <div className="col-2 d-flex justify-content-left print-text">
                        {names[index]}
                      </div>
                      <div className="col-2 d-flex justify-content-left print-text text-right align-right">
                        {subtotals[index]}
                      </div>
                      <div className="col-3 d-flex justify-content-left print-text text-right align-right"></div>
                    </div>
                  );
                })}
            </>
          );
        })}
        <div className="dotted-line"></div>
        <div className="row">
          <div className="col d-flex justify-content-left print-text">
            Total Amount: {numberWithCommas(total)}
          </div>
        </div>
        <div className="row">
          <div className="col d-flex justify-content-left print-text">
            Total {props.name === "Senior Citizen Report" ? "SC" : "PWD"}:{" "}
            {numOfSCPWD}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="container">
      <style>{getPageMargins()}</style>
      <div className="print-area rounded p-4 single-width printing">
        {headers()}
        {props.name === "Item History Report" && contentItemReports()}
        {props.name === "Cash Counts Report" && contentCashCountReport()}
        {(props.name === "Adjustment Trans. Report" ||
          props.name === "Void Trans. Report") &&
          contentAdjustmentVoidReport()}
        {props.name === "Daily Sales Report" && dailySalesReports()}
        {props.name === "Senior Citizen Report" && seniorPWDDiscountsReports()}
        {props.name === "PWD Sales Report" && seniorPWDDiscountsReports()}
        {footer()}
      </div>
    </div>
  );
}

export class PrintReportReceipts extends React.PureComponent {
  render() {
    return printReceipt(this.props);
  }
}

export default PrintReportReceipts;
